import SectionLabel from './SectionLabel'
import ReviewCard from './ReviewCard'
import { reviews } from '../data/reviews'

export default function ReviewsSection() {
  const previews = reviews.slice(0, 3)

  return (
    <section className="section bg-stone">
      <SectionLabel>Client Reviews</SectionLabel>
      <h2 className="section-title">Word of mouth.</h2>
      <p className="section-sub">
        Real reviews from genuine explorers who have crossed the high passes with us.
      </p>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
        gap: '24px', 
        marginTop: '20px' 
      }}>
        {previews.map(r => (
          <ReviewCard key={r.id} review={r} />
        ))}
      </div>
    </section>
  )
}
